export default "__VITE_ASSET__DU7UejFP__"